// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var MM_wrk_client = require("./MM_wrk_client.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var procName = "MM_wrk_ParseMmFile";

function beginParsingMmFile(mmFileText, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, /* ParseMmFile */{
        mmFileText: mmFileText
      }, (function (resp, sendToWorker, endWorkerInteraction) {
          if (resp.TAG === /* MmFileParseProgress */0) {
            return Curry._1(onProgress, resp.pct);
          }
          Curry._1(endWorkerInteraction, undefined);
          Curry._1(onDone, resp.parseResult);
        }), undefined, undefined);
}

function processOnWorkerSide(req, sendToClient) {
  try {
    var parseResult = MM_parser.parseMmFile(req.mmFileText, (function (pct) {
            Curry._1(sendToClient, {
                  TAG: /* MmFileParseProgress */0,
                  pct: pct
                });
          }), undefined);
    Curry._1(sendToClient, {
          TAG: /* MmFileParseProgress */0,
          pct: 1
        });
    return Curry._1(sendToClient, {
                TAG: /* MmFileParsed */1,
                parseResult: {
                  TAG: /* Ok */0,
                  _0: parseResult
                }
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === MM_parser.MmException) {
      return Curry._1(sendToClient, {
                  TAG: /* MmFileParsed */1,
                  parseResult: {
                    TAG: /* Error */1,
                    _0: exn._1.msg
                  }
                });
    }
    throw exn;
  }
}

exports.procName = procName;
exports.beginParsingMmFile = beginParsingMmFile;
exports.processOnWorkerSide = processOnWorkerSide;
/* No side effect */
